import { useCallback, useState } from 'react'
import { centsClient } from '../../api/cents/clients/cents-client'
interface ContractFinalizationHook {
  state: 'idle' | 'finalize' | 'success'
  finalize: (setupIntent: string) => Promise<void>
}
interface Props {
  charityId: string
  contractId: string
  success: () => Promise<void>
  failure: (e: unknown) => void
}
export function useUpdatePaymentMethodFinalization({ charityId, contractId, success, failure }: Props): ContractFinalizationHook {
  const [state, setState] = useState<'idle' | 'finalize' | 'success'>('idle')

  const finalize = useCallback(async (setupIntent: string) => {
    setState('finalize')
    try {
      await centsClient.contracts.updateSubscription(charityId, contractId, { stripeSetupIntentId: setupIntent })
      setState('success')
      void success()
    } catch (e) {
      failure(e)
    }
  }, [charityId, contractId])
  return { state, finalize }
}
